import React from 'react';
import axios from 'axios';
import { configAPI } from '../config'


export default class YemotMFAHandler {

    constructor(token) {
        if (!token) throw new Error(`yemot mfa requires token`);
        this.token = token;
    }

    async duAPI(ws, prms) {
        const headers = {
            'authorization': this.token,
            'content-type': 'application/json'
        };

        const url = `${configAPI.api.prod}${ws}`;
        const data = prms;

        const res = await axios.post(url, data, { headers });
        return res.data;
    }

    async isPass() {
        const res = await this.duAPI(`MFASession`, { action: 'isPass' });
        if (res && res.responseStatus === "OK" && res.isPass && res.isPass === true) return true;
        return false;
    }

    async tryPass() {
        const res = await this.duAPI(`MFASession`, { action: 'try', ym_api_send_uniq_customer: true });
        if (res && res.responseStatus !== "OK" && res.responseStatus !== "FORBIDDEN") return true;
        if (res && res.responseStatus === "OK" && res.isPass && res.isPass === true) return true;
        return false;
    }

    async validOrPass() {
        if (await this.isPass()) return {
            status: true,
            useTry: false
        };
        return {
            status: await this.tryPass(),
            useTry: true
        };
    }

}